import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, Renderer2, SimpleChanges, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Utils } from 'app/components/utils/Utils';
import { Log } from 'app/core/logging/log';
import { ItemCart, ParameterCart } from 'app/models/cart-model';
import { Images, Item } from 'app/models/stock-model';
import { StockPromotionModel } from 'app/models/stock-promotion-model';
import { AppService } from 'app/services/app/app.service';
import { SharedModule } from 'app/shared.module';


export enum ModeEnum {
    LINK_TYPE, 
    LINK_SIZE, //TODO eliminar
    PRICE_SIZE_SIMPLE, //TODO eliminar
    PRICE_SIZE
  }

@Component({
    selector: 'app-offer-locker',
    templateUrl: './offer-locker.component.html',
    styleUrls: ['./offer-locker.component.scss'],
    imports: [SharedModule],
    standalone: true
})
export class OfferLockerComponent implements OnInit, AfterViewInit {
    readonly defaultLockerImage = 'assets/img/placeholder.jpg';

    @ViewChildren('description') descriptions!: QueryList<ElementRef<HTMLDivElement>>;
    @ViewChildren('promotions') promotions!: QueryList<ElementRef<HTMLDivElement>>;
    @Input('forceAvailabled') forceAvailabled: boolean = false;
    @Input('lockers') lockers: Item[] = [];
    @Input('prices') prices: StockPromotionModel;
    @Input('mode') mode: ModeEnum = ModeEnum.PRICE_SIZE;
    @Input('type') type: number = null;
    @Output() callBack = new EventEmitter<any>();
    @Output() categoryCallBack = new EventEmitter<any>();
    itemsCart: ItemCart[] = [];
    parameters: ParameterCart = {
        items: [],
        startDate: undefined,
        endDate: undefined,
        type: null
    };
    public ModeEnum = ModeEnum;

    constructor(
                private route: ActivatedRoute,
                public appService: AppService
                ) { }

    ngOnInit() {
        this.parameters = Utils.getParams(this.route.snapshot.queryParamMap);
        this.itemsCart = this.parameters.items;

        if(this.type != null){
            this.parameters.type = this.type;
        }
        Log.debug("lockers", {lockers:this.lockers});
        
    }

    ngAfterViewInit() {
        setTimeout(()=> this.heightDescription(), 500);
        setTimeout(()=> this.heightPromotions(), 500);
    }

    heightDescription() {
        if(this.descriptions){
            let height:number = null;
            this.descriptions.forEach((box, index) => {
                //box.nativeElement.style.backgroundColor = index % 2 === 0 ? 'lightblue' : 'lightgreen';
                //console.log(`Caja ${index + 1} altura:`, box.nativeElement.offsetHeight);
                height = (height == null || height < box.nativeElement.offsetHeight) ? box.nativeElement.offsetHeight : height;
            });  
            this.descriptions.forEach((box, index) => {
                box.nativeElement.style.height = height + 'px';
            });  
            //console.log('height', height); 
        }
    }
    

    heightPromotions() {
        if(this.promotions){
            let height:number = null;
            this.promotions.forEach((box, index) => {
                //box.nativeElement.style.backgroundColor = index % 2 === 0 ? 'lightblue' : 'lightgreen';
                //console.log(`Caja ${index + 1} altura:`, box.nativeElement.offsetHeight);
                height = (height == null || height < box.nativeElement.offsetHeight) ? box.nativeElement.offsetHeight : height;
            });  
            this.promotions.forEach((box, index) => {
                box.nativeElement.style.height = height + 'px';
            });  
            //console.log('height', height); 
        }
    }
      

    
    ngOnChanges(changes: SimpleChanges) {
        Log.debug("ngOnChanges", {changes:changes});
        //if(changes.lockers != undefined){
          //  console.log('ngOnChanges lockers', changes.lockers.currentValue);

         //   console.log('this.parameters', this.parameters);
            //if(this.parameters.startDate == null && this.parameters.endDate == null){
                //for(let locker of this.lockers){
                    //console.log('this.lockers', this.lockers);
                    //locker.available=1;
                //}
            //}

           
        //}
 
        if(changes.prices != undefined){

            //for(let locker of this.lockers){
             //   console.log(locker);
            //    console.log(this.prices);
            //    console.log('>>>>>>>', this.prices?.items[locker.key]?.price);
            //}
        }
        
    }
    

    selectProduct(locker:Item){
        
    }

    plus(locker:Item){
        locker['more'] = false;
        this.setSizeLocker(locker, true);
    }

    less(locker:Item){
        this.setSizeLocker(locker, false);
    }

    setSizeLocker(locker:Item, plus:boolean):ItemCart{
        let sizeLocker:ItemCart;
        let index = -1;

        if(this.itemsCart!=undefined && this.itemsCart.length>0){
            index = this.itemsCart.findIndex(i => i.categoryId === locker.id);
            sizeLocker = this.itemsCart[index];
        }

        if(sizeLocker == null){
            if(!plus) return;
            sizeLocker = {
                categoryId: locker.id
            };
        }

        if(plus){
            this.itemsCart.push(sizeLocker);
        }else{
            this.itemsCart.splice(index, 1);
        }
        this.callBack.emit(this.itemsCart);
    }

    getAmount(item:Item){
        //Log.info("item", {item: item});
        //Log.info("itemsCart", {itemsCart: this.itemsCart});
        let l = this.itemsCart.filter(i=>i.categoryId == item.id);
        //Log.info("item en cart", {item:l});
        return l ? l.length : 0;
    }

    generateParams(category: Item){
        if (this.isType(category)) {
            this.parameters.items = [];
            this.parameters.startDate = undefined;
            this.parameters.endDate = undefined;
            this.parameters.type = category.id;
        }else{
            this.parameters.items = [
                {
                    //type: this.parameters.type,
                    categoryId: category.id
                }
            ];
        }
        return Utils.generateParams(this.parameters);
    }

    isType(category: Item){
        return !category.hasOwnProperty('type');
    }

    onClickCategory(item: Item){
        Log.debug('onClickCategory', {item});
        const e = {
            item: item,
            param: this.generateParams(item)
        }
        this.categoryCallBack.emit(e);
    }

    getLockerImage(locker: Item): string {
        return locker?.images?.imageMedium
            || locker?.images?.imageLarge
            || locker?.images?.imageSmall
            || this.defaultLockerImage;
    }

    getLockerSrcSet(locker: Item): string | null {
        const images: Images = locker?.images;
        if (!images) {
            return null;
        }

        const srcSetParts = [
            images.imageSmall ? `${images.imageSmall} 200w` : null,
            images.imageMedium ? `${images.imageMedium} 400w` : null,
            images.imageLarge ? `${images.imageLarge} 800w` : null
        ].filter(Boolean);

        return srcSetParts.length > 0 ? srcSetParts.join(', ') : null;
    }
}
